import UserInfo from '@/lib/user-info'

export default {
  computed: {
    controlBackgroundColor() {
      if (this.$vuetify.theme.dark) {
        return ''
      }
      return 'white'
    },
  },
  methods: {
    hasFreeFunctionality() {
      return UserInfo.hasFreeFunctionality()
    },
  },
}
